﻿
cb.define([], function() {
	var AA_aa_storelist_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			//过滤条件枚举型选择全部时移除该条件
			var gridModel = viewmodel.getGridModel();
			gridModel.on('beforeLoad', function(data) {
				var common = data.condition.commonVOs;
				if(common != undefined && common.length > 0) {
					var datas = [];
					common.forEach(function(item) {
						if(item.itemName == "stop" && item.value1 == "-1") {

						} else {
							datas.push(item);
						}

					});
					data.condition.commonVOs = datas;
				}
			});
			//批量停用
			viewmodel.on('batchclose', function(args) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择门店！', 'warning');
					return false;
				}

				var url = '/bill/batchDo?action=stop';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});

				var datas = [];
				var length = selectedRows.length;
				for(var i = 0; i < length; i++) {
					datas.push({
						"id": selectedRows[i]["id"],
					});
				}
				var params = {
					billnum: "aa_storelist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
				});
			});
			//批量启用
			viewmodel.on('batchopen', function(args) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择门店！', 'warning');
					return false;
				}

				var url = '/bill/batchDo?action=unstop';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});

				var datas = [];
				var length = selectedRows.length;
				for(var i = 0; i < length; i++) {
					datas.push({
						"id": selectedRows[i]["id"],
					});
				}
				var params = {
					billnum: "aa_storelist",
					data: JSON.stringify(datas)
				}
				proxy.ensure(params, function(err, result) {
					if(err) {
						cb.utils.alert(err.message, 'error');
						return;
					}
					cb.utils.alert('操作成功', 'success');
					viewmodel.execute('refresh');
				});
			});
			//周边门店组字段所在的隐藏的viewmodel
			var storeGroupReferModel = new cb.models.ReferModel({
				cRefType: 'aa_adjacentstoregroup'
			});
			viewmodel.addProperty('storegroup', storeGroupReferModel);
			storeGroupReferModel.setVisible(false)
			//加入周边门店组的批量操作
			viewmodel.on('addstoregroup', function(args) {
				storeGroupReferModel.setCache('args', args);
				storeGroupReferModel.browse();
			});
			//加入周边门店组之前判断是否选择门店
			storeGroupReferModel.on('beforeBrowse', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择门店！', 'warning');
					return false;
				}
			});
			storeGroupReferModel.on('afterValueChange', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				var selectedStoregroupId = data.value.id;
				var url = '/bill/batchDo?action=addstoregroup';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});
				var datas = [];
				if(selectedStoregroupId == undefined || selectedStoregroupId.length == 0) {
					cb.utils.alert('未选择门店组！', 'warning');
				} else {
					var length = selectedRows.length;
					for(var i = 0; i < length; i++) {

						datas.push({
							"store": selectedRows[i]["id"],
							"adjacentStoreGroup": selectedStoregroupId,
						});
					}
					var params = {
						billnum: "aa_storelist",
						data: JSON.stringify(datas)
					}
					proxy.ensure(params, function(err, result) {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}
						debugger
						if(result) {
							var count = result.count;
							var sucessCount = result.sucessCount;
							var failCount = result.failCount;
							if(result.messages.length > 0) {
								var messages = result.messages;
								var stores = '';
								var length = messages.length;
								for(var i = 0; i < length; i++) {
									stores += messages[i];
									stores += "、";
								}
								var stores2 = stores.substring(0, stores.length -1);
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。 ' + stores2 + '已加入周边门店组，此次操作未对其生效！', 'warning');
							} else {
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。', 'success');
							}

						}
						viewmodel.execute('refresh');
					});
				}
			});
			// 			//确认开店批量操作
			// 			viewmodel.on('openshop', function(args) {
			// 				//    	var currentRow = viewmodel.getGridModel().getRow(args.params.index);
			// 				var selectedRows = viewmodel.getGridModel().getSelectedRows();
			// 				if(selectedRows == undefined || selectedRows.length == 0) {
			// 					cb.utils.alert('未选择门店！', 'warning');
			// 					return false;
			// 				}
			// 				var proxy = cb.rest.DynamicProxy.create({
			// 					ensure: {
			// 						url: args.cSvcUrl,
			// 						method: args.cHttpMethod
			// 					}
			// 				});
			// 				var params = {
			// 					billnum: "aa_storelist",
			// 					data: JSON.stringify(selectedRows)
			// 				}
			// 				proxy.ensure(params, function(err, result) {
			// 					if(err) {
			// 						cb.utils.alert(err.message, 'error');
			// 						return;
			// 					}
			// 					if(result != null) {
			// 						cb.utils.alert(result, 'success');
			// 					}
			// 					viewmodel.execute('refresh');
			// 				});
			// 			});
		}
	}
	try {
		module.exports = AA_aa_storelist_VM_Extend;
	} catch(error) {

	}
	return AA_aa_storelist_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_storelist_VM.Extend.js